import type { Http } from "../http";
import { parseBody } from "../models/common";
import { remediesSchema, transitsSchema, type Remedies, type Transits } from "../models/daily";
import { forecastSchema, type Forecast, type ForecastPeriod } from "../models/forecast";
import { lifeIndexSchema, lifeReadingSchema, type LifeIndex, type LifeReading, type LifeReadingName } from "../models/life";

/** A fresh forecast may call the model, which takes a few seconds. */
const FORECAST_TIMEOUT_MS = 45_000;

/** The day, week and month forecasts, transits, remedies and the Life readings. */
export function dailyEndpoints(http: Http) {
  return {
    async fetchForecast(period: ForecastPeriod): Promise<Forecast> {
      return parseBody(forecastSchema, await http.get("/me/forecast", { query: { period }, timeoutMs: FORECAST_TIMEOUT_MS }));
    },
    async fetchTransits(): Promise<Transits> {
      return parseBody(transitsSchema, await http.get("/me/transits"));
    },
    async fetchRemedies(): Promise<Remedies> {
      return parseBody(remediesSchema, await http.get("/me/remedies"));
    },
    async fetchLifeIndex(): Promise<LifeIndex> {
      return parseBody(lifeIndexSchema, await http.get("/me/life"));
    },
    /**
     * One reading, computed fresh. Rejects with 402 when the person is not a
     * subscriber — the caller answers that with the wall, not an error.
     */
    async fetchLifeReading(reading: LifeReadingName): Promise<LifeReading> {
      return parseBody(lifeReadingSchema, await http.get(`/me/life/${reading}`));
    },
  };
}
